import { formatFitScoreBadge } from "./matchScoreUtils";

/**
 * Format cluster social proof for match UI.
 * @param {{ ownerCount?: number, highRatedCount?: number, summary?: string|null, hasSocialProof?: boolean }} proof
 */
export function formatSocialProofLine(proof) {
  if (!proof?.hasSocialProof) return null;
  if (proof.summary && typeof proof.summary === "string") {
    return proof.summary;
  }

  const parts = [];
  const owners = proof.ownerCount || 0;
  const rated = proof.highRatedCount || 0;

  if (owners > 0) {
    const noun = owners === 1 ? "person" : "people";
    const verb = owners === 1 ? "owns" : "own";
    parts.push(`${owners} ${noun} with similar taste ${verb} this`);
  }
  if (rated > 0) {
    parts.push(`${rated} rated it highly`);
  }

  return parts.length ? parts.join(" · ") : null;
}

/**
 * Single line: "91 Fit score · 14 people with similar taste own this · …"
 * @param {number|null|undefined} score
 * @param {object|null|undefined} proof
 */
export function formatFusedMatchScoreLine(score, proof) {
  if (score == null || !Number.isFinite(Number(score))) {
    return formatSocialProofLine(proof);
  }

  const scorePart = formatFitScoreBadge(score);
  const proofPart = formatSocialProofLine(proof);
  if (!proofPart) return scorePart;
  return `${scorePart} · ${proofPart}`;
}
